import { render } from "./companyStatistics.vue?vue&type=template&id=418b1aa2&scoped=true"
import script from "./companyStatistics.vue?vue&type=script&lang=js"
export * from "./companyStatistics.vue?vue&type=script&lang=js"

import "./companyStatistics.vue?vue&type=style&index=0&id=418b1aa2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-418b1aa2"

export default script